import React, { useCallback } from 'react';
import { useSnackbar as useSnackbarNotistack } from 'notistack';

const useSnackbar = () => {
  const { enqueueSnackbar } = useSnackbarNotistack();

  const showSnackbar = useCallback(
    (mensaje: string | React.ReactNode) => {
      enqueueSnackbar(mensaje, {
        variant: 'default',
      });
    },
    [enqueueSnackbar],
  );

  const showSnackbarError = useCallback(
    (mensaje: string | React.ReactNode) => {
      enqueueSnackbar(mensaje, {
        variant: 'error',
      });
    },
    [enqueueSnackbar],
  );

  const showSnackbarInfo = useCallback(
    (mensaje: string | React.ReactNode) => {
      enqueueSnackbar(mensaje, {
        variant: 'info',
      });
    },
    [enqueueSnackbar],
  );

  const showSnackbarSuccess = useCallback(
    (mensaje: string | React.ReactNode) => {
      enqueueSnackbar(mensaje, {
        variant: 'success',
      });
    },
    [enqueueSnackbar],
  );

  const showSnackbarWarning = useCallback(
    (mensaje: string | React.ReactNode) => {
      enqueueSnackbar(mensaje, {
        variant: 'warning',
      });
    },
    [enqueueSnackbar],
  );

  return {
    showSnackbar,
    showSnackbarError,
    showSnackbarInfo,
    showSnackbarSuccess,
    showSnackbarWarning,
  };
};

export default useSnackbar;
